import Space from 'antd/lib/space';
import {
  Button,
  DataGrid,
  IconButton,
  Input,
  Large,
  Modal,
  Text,
  CustomTooltip,
} from 'components';
import { permissions } from 'constant/permissions';
import React, { useState } from 'react';
import {
  useDeleteDeliveryMethodMutation,
  useGetDeliveryMethodListQuery,
} from 'redux/slices/deliveryMethod/deliveryMethodApi';
import { hasPermission } from 'utils/helper';
import { roleSettingsSelector } from 'redux/slices/app/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Controller, useForm, useWatch } from 'react-hook-form';
import CreateDeliveryMethod from './CreateDeliveryMethod/CraeteDeliveryMethod';
import { i18n } from 'constant/String';
import { apiResHandler } from 'utils/axiosBaseQuery';
import { addAlertQueue } from 'redux/slices/snackbar/snackbarSlice';

const DeliveryMethod = () => {
  const { data = [] } = useGetDeliveryMethodListQuery();
  const [deleteDeliveryMethod] = useDeleteDeliveryMethodMutation();
  const dispatch = useDispatch();

  const [modalOpen, setModalOpen] = useState({
    show: false,
    data: null,
  });
  const [deleteShowModal, setDeleteShowModal] = useState({
    show: false,
    id: null,
  });
  const { control } = useForm();
  const roleSettingsInfo = useSelector(roleSettingsSelector);
  const deliveryMethodSearch = useWatch({
    control,
    name: 'seachDeliveryMethod',
  });
  const columns = [
    {
      title: 'Teslimat Biçimi',
      dataField: 'shortName',
      minWidth: 200,
    },
    {
      title: 'Teslimat Biçimi Kodu',
      dataField: 'formatCode',
      minWidth: 200,
    },
    {
      title: 'Detay', 
      dataField: 'details',
      minWidth: 400,
    },
    {
      title: 'Açıklama',
      dataField: 'description',
      minWidth: 200,
    },
    {
      title: 'İşlemler',
      dataField: 'operation',
      minWidth: 200,
      allowFiltering: false,
      cellRender: (row) => (
        <div className="flex w-full gap-x-4 justify-center">
          {hasPermission(
            permissions.deliveryTypeDefinition,
            'UPDATE',
            roleSettingsInfo
          ) ? (
            <CustomTooltip
              textForTip="Düzenle"
              tooltipClassname="bg-primary text-white whitespace-nowrap"
              location="top"
              showEvent="mouseenter"
              hideEvent="mouseleave"
            >
              <IconButton
                icon={<i className="fa-solid fa-pen-to-square" />}
                onClick={() => {
                  setModalOpen({
                    show: true,
                    data: row.data,
                  });
                }}
              />
            </CustomTooltip>
          ) : null}
          {hasPermission(
            permissions.deliveryTypeDefinition,
            'DELETE',
            roleSettingsInfo
          ) ? (
            <CustomTooltip
              textForTip="Sil"
              tooltipClassname="bg-primary text-white whitespace-nowrap"
              location="top"
              showEvent="mouseenter"
              hideEvent="mouseleave"
            >
              <IconButton
                icon={<i className="fa-solid fa-trash text-red" />}
                onClick={() => setDeleteShowModal({ show: true, id: row.data.id })}
              />
            </CustomTooltip>
          ) : null}
        </div>
      ),
    },
  ];

  const handleDelete = () => {
    apiResHandler(
      deleteDeliveryMethod({ id: deleteShowModal.id }),
      () => {
        dispatch(
          addAlertQueue({
            message: 'Teslimat Biçimi Silindi',
            status: 'success',
            show: true,
          })
        );
        setDeleteShowModal({ show: false, id: null });
      },
      ({ message }) => {
        addAlertQueue({
          message: message,
          status: 'error',
          show: true,
        });
      }
    );
  };

  return (
    <>
      <Space className="mb-4 flex justify-between w-full gap-y-2 md:gap-y-0 flex-col md:flex-row">
        <div className="flex w-full gap-x-0 sm:gap-x-3 gap-y-2 sm:gap-y-2">
          <form>
            <Controller
              name="seachDeliveryMethod"
              control={control}
              render={({ field }) => (
                <Input
                  placeholder="Teslimat Biçimi Giriniz"
                  className="px-4 rounded-xl items-center w-80"
                  inputClassName="border-none"
                  {...field}
                />
              )}
            />
          </form>
        </div>
        {hasPermission(
          permissions.deliveryTypeDefinition,
          'CREATE',
          roleSettingsInfo
        ) ? (
          <Button
            text="Teslimat Biçimi Ekle"
            className="bg-primary gap-x-2"
            textVariant="white"
            onClick={() =>
              setModalOpen({
                show: true,
                data: null,
              })
            }
          />
        ) : null}
      </Space>
      <DataGrid
        dataSource={
          deliveryMethodSearch
            ? data?.data?.filter((deliveryMethod) =>
                deliveryMethod?.description
                  ?.toLocaleUpperCase()
                  .includes(deliveryMethodSearch.toLocaleUpperCase())
              )
            : data?.data
        }
        columns={columns} 
        allowHeaderFiltering={true}
        showBorders={true}
        showColumnLines={true}
        showRowLines={true}
      />

      <Modal
        isOpen={modalOpen.show}
        handleModalClose={() =>
          setModalOpen({
            show: false,
            data: null,
          })
        }
      >
        <CreateDeliveryMethod
          data={modalOpen?.data}
          onCancel={() =>
            setModalOpen({
              show: false,
              data: null,
            })
          }
        />
      </Modal>
      <Modal
        isOpen={deleteShowModal.show}
        handleModalClose={() => setDeleteShowModal({ show: false, id: null })}
        ModalClass="bg-sky-light"
      >
        <div className="flex flex-col p-1 text-center gap-y-4">
          <Large weight="semibold">{i18n.message.areYouSureDelete}</Large>
          <Text>{i18n.message.deleteDeliveryType}</Text>
          <div className="flex gap-x-2 flex-col md:flex-row">
            <Button
              className="mt-2 bg-ink-lighter"
              textVariant="white"
              text="İptal"
              onClick={() =>
                setDeleteShowModal({
                  show: false,
                  id: null,
                })
              }
            />
            <Button
              className="mt-2 bg-primary"
              textVariant="white"
              text="Sil"
              onClick={handleDelete}
              rightIcon={<i className="fa-solid fa-trash text-red" />}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default DeliveryMethod;
